import React from 'react'
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom'

import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

import useStyles from '../styles/Styles';

import dayjs from 'dayjs'

const Footer = ({extraMessage, adminLogin}) => {
	const generalSettings = useSelector(state => state.settings.general);
	const version = useSelector(state => state.uMAS4MVersion);
	const classes = useStyles();
	
	return (
		<div className={classes.footer} >
		<Divider />
		<Typography variant="body2">
		{generalSettings.data.state === 'VIC' ?
		<Link 
			href='https://www.u3avictoria.com.au/' 
			target='_blank'
			rel='noopener'
			underline='hover'
		>U3A Network Victoria Inc.</Link> :
		<>{generalSettings.data.formal_name}</>} membership management system, provided under license from <Link 
			href='https://membershipadmin.com.au/' 
			target='_blank'
			rel='noopener'
			underline='hover'
		>Soft Sys membership software</Link>.
		{generalSettings.expires > 0 ? <> U-MAS version: {generalSettings.data.umas_version}, release date: {dayjs(generalSettings.data.umas_date).format('D MMM YYYY')}.</> : null} U-MAS for Members version: {version.version}.{dayjs(version.date).format('YYYYMMDD')}. {extraMessage ? extraMessage : null} {adminLogin ? <Link 
			component={RouterLink}
			to={adminLogin} 
			underline='hover'
		>Admin</Link> : null}
		</Typography>
		</div>
)}

export default Footer
